import { render, staticRenderFns } from "./selectOptionDictionary.vue?vue&type=template&id=688e794e"
import script from "./selectOptionDictionary.vue?vue&type=script&lang=js"
export * from "./selectOptionDictionary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports